import { render, staticRenderFns } from "./SlideoutMenu.vue?vue&type=template&id=0d523888&scoped=true&"
import script from "./SlideoutMenu.vue?vue&type=script&lang=js&"
export * from "./SlideoutMenu.vue?vue&type=script&lang=js&"
import style0 from "./SlideoutMenu.vue?vue&type=style&index=0&id=0d523888&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d523888",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/induline.salamander.live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d523888')) {
      api.createRecord('0d523888', component.options)
    } else {
      api.reload('0d523888', component.options)
    }
    module.hot.accept("./SlideoutMenu.vue?vue&type=template&id=0d523888&scoped=true&", function () {
      api.rerender('0d523888', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/ui/SlideoutMenu.vue"
export default component.exports